import styled, { css } from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Checkbox from '@atoms/Checkbox/Checkbox';
import Text from '@atoms/Text/Text';
import Button from '@atoms/Button/Button';

export const StyledFilterList = styled(Button)<{ $expanded: boolean }>`
  && {
    min-width: 100%;
    border-bottom: ${rem(1)} solid ${variables.colors.mediumGray};
    margin: 0;
    min-height: ${rem(72)};
    border-radius: ${rem(2)};
    cursor: pointer;
    color: ${variables.colors.lighterBlack};
    padding: ${rem(17)} ${rem(20)};
    font-size: ${rem(15)};
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: ${rem(20)};
    outline-offset: 0;

    ${(props) =>
      props.$expanded &&
      css`
        border-color: transparent;
        color: ${variables.colors.primary};
      `}
  }
`;

export const StyledFilterListSpan = styled.span`
  display: flex;
  align-self: start;
  font-family: ${variables.fonts.fontGothamMedium};
`;

export const StyledFilterListOptions = styled.div<{ $expanded: boolean }>`
  flex-basis: 100%;
  order: 99;
  display: none;
  transition: max-height 1s ease;
  padding: 0 ${rem(20)};

  ${(props) =>
    props.$expanded &&
    css`
      display: block;
    `}
`;

export const StyledFilterListCheckbox = styled(Checkbox)`
  left: ${rem(10)};
  position: relative;
`;
export const StyledFilterListLabel = styled.label`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${rem(16)};
  cursor: pointer;
`;
export const StyledFilterCheckBoxAndCount = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(4)};
`;

export const StyledFilterListSelectedText = styled(Text)`
  display: inline;
`;

export const StyledFilterListSelectedTextContainer = styled.div`
  text-wrap: wrap;
  text-align: left;
`;
